import { api } from '../api'
import type { ApiTableRemoveBot } from '@acepoker/contract'

export const removeBot = async (data: ApiTableRemoveBot): Promise<{ code: number }> => {
  const response = await api()
    .url('/api/table/bot')
    .content('application/json')
    .body(JSON.stringify(data))
    .delete()
    .res()

  if (!response.ok) {
    throw new Error(`Failed to remove bot: ${response.status} ${response.statusText}`)
  }

  return { code: 200 }
}
